"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpiceModelTypeSchema = exports.SpiceModelType = exports.SpiceMeasurementTypeSchema = exports.SpiceMeasurementType = exports.SpiceAnalysisTypeSchema = exports.SpiceAnalysisType = exports.SpiceLinesSchema = exports.SpiceLines = exports.SpiceDotCommandsSchema = exports.SpiceDotCommands = exports.SpiceElementTypeSchema = exports.SpiceElementType = void 0;
const zod_1 = require("zod");
var SpiceElementType;
(function (SpiceElementType) {
    SpiceElementType[SpiceElementType["Circuit"] = 0] = "Circuit";
    SpiceElementType[SpiceElementType["Net"] = 1] = "Net";
    SpiceElementType[SpiceElementType["Operation"] = 2] = "Operation";
    SpiceElementType[SpiceElementType["ModelDefinition"] = 3] = "ModelDefinition";
    SpiceElementType[SpiceElementType["Include"] = 4] = "Include";
    SpiceElementType["XspiceCodeModel"] = "A";
    SpiceElementType["BehavioralSource"] = "B";
    SpiceElementType["Capacitor"] = "C";
    SpiceElementType["Diode"] = "D";
    SpiceElementType["VoltageControlledVoltageSource"] = "E";
    SpiceElementType["NonLinearVoltageSource"] = "E";
    SpiceElementType["CurrentControlledCurrentSource"] = "F";
    SpiceElementType["VoltageControlledCurrentSource"] = "G";
    SpiceElementType["NonLinearCurrentSource"] = "G";
    SpiceElementType["CurrentControlledVoltageSource"] = "H";
    SpiceElementType["CurrentSource"] = "I";
    SpiceElementType["JFET"] = "J";
    SpiceElementType["CoupledInductors"] = "K";
    SpiceElementType["Inductor"] = "L";
    SpiceElementType["MOSFET"] = "M";
    SpiceElementType["NumericalDeviceForGSS"] = "N";
    SpiceElementType["LossyTransmissionLine"] = "O";
    SpiceElementType["CoupledMulticonductorLine"] = "P";
    SpiceElementType["BJT"] = "Q";
    SpiceElementType["Resistor"] = "R";
    SpiceElementType["SwitchVoltageControlled"] = "S";
    SpiceElementType["LosslessTransmissionLine"] = "T";
    SpiceElementType["UniformlyDistributedRCLine"] = "U";
    SpiceElementType["VoltageSource"] = "V";
    SpiceElementType["SwitchCurrentControlled"] = "W";
    SpiceElementType["Subcircuit"] = "X";
    SpiceElementType["SingleLossyTransmissionLine"] = "Y";
    SpiceElementType["MESFET"] = "Z";
})(SpiceElementType || (exports.SpiceElementType = SpiceElementType = {}));
exports.SpiceElementTypeSchema = zod_1.default.nativeEnum(SpiceElementType);
var SpiceDotCommands;
(function (SpiceDotCommands) {
    SpiceDotCommands["ACSimulation"] = ".AC";
    SpiceDotCommands["ControlSectionStart"] = ".CONTROL";
    SpiceDotCommands["ControlSectionParameters"] = ".CSPARAM";
    SpiceDotCommands["DCSimulation"] = ".DC";
    SpiceDotCommands["DistortionAnalysisSimulation"] = ".DISTO";
    SpiceDotCommands["ConditionalElse"] = ".ELSE";
    SpiceDotCommands["ConditionalElseIf"] = ".ELSEIF";
    SpiceDotCommands["NetlistEnd"] = ".END";
    SpiceDotCommands["ControlSectionEnd"] = ".ENDC";
    SpiceDotCommands["ConditionalBranchingEnd"] = ".ENDIF";
    SpiceDotCommands["SubcircuitDefinitionEnd"] = ".ENDS";
    SpiceDotCommands["FourierAnalysisSimulation"] = ".FOUR";
    SpiceDotCommands["FunctionDefinition"] = ".FUNC";
    SpiceDotCommands["GlobalNodeDefinition"] = ".GLOBAL";
    SpiceDotCommands["SetInitialConditions"] = ".IC";
    SpiceDotCommands["ConditionIfBranch"] = ".IF";
    SpiceDotCommands["IncludePart"] = ".INCLUDE";
    SpiceDotCommands["IncludeLibrary"] = ".LIB";
    SpiceDotCommands["SimulationMeasurements"] = ".MEAS";
    SpiceDotCommands["DeviceModelParameters"] = ".MODEL";
    SpiceDotCommands["SetNodeInitialConditions"] = ".NODESET";
    SpiceDotCommands["NoiseSimulation"] = ".NOISE";
    SpiceDotCommands["OperatingPointSimulation"] = ".OP";
    SpiceDotCommands["SimulatorOptions"] = ".OPTIONS";
    SpiceDotCommands["ParameterDefinition"] = ".PARAM";
    SpiceDotCommands["Plot"] = ".PLOT";
    SpiceDotCommands["Print"] = ".PRINT";
    SpiceDotCommands["Probe"] = ".Probe";
    SpiceDotCommands["PeriodicSteadyStateAnalysis"] = ".PSS";
    SpiceDotCommands["PoleZeroSimulation"] = ".PZ";
    SpiceDotCommands["Save"] = ".SAVE";
    SpiceDotCommands["SParameterAnalysis"] = ".SP";
    SpiceDotCommands["SubcircuitDefinitionStart"] = ".SUBCKT";
    SpiceDotCommands["CircuitTemperature"] = ".TEMP";
    SpiceDotCommands["TransferFunctionAnalysis"] = ".TF";
    SpiceDotCommands["TransientSimulation"] = ".TRAN";
    SpiceDotCommands["PlotWidth"] = ".WIDTH";
})(SpiceDotCommands || (exports.SpiceDotCommands = SpiceDotCommands = {}));
exports.SpiceDotCommandsSchema = zod_1.default.nativeEnum(SpiceDotCommands);
var SpiceLines;
(function (SpiceLines) {
    SpiceLines["Title"] = ".TITLE";
    SpiceLines["End"] = ".END";
    SpiceLines["ContinuationLine"] = "+";
    SpiceLines["CommentLine"] = "*";
})(SpiceLines || (exports.SpiceLines = SpiceLines = {}));
exports.SpiceLinesSchema = zod_1.default.nativeEnum(SpiceLines);
var SpiceAnalysisType;
(function (SpiceAnalysisType) {
    SpiceAnalysisType["DC"] = "dc";
    SpiceAnalysisType["AC"] = "ac";
    SpiceAnalysisType["Transient"] = "tran";
    SpiceAnalysisType["Noise"] = "noise";
    SpiceAnalysisType["Distortion"] = "disto";
    SpiceAnalysisType["OperatingPoint"] = "op";
})(SpiceAnalysisType || (exports.SpiceAnalysisType = SpiceAnalysisType = {}));
exports.SpiceAnalysisTypeSchema = zod_1.default.nativeEnum(SpiceAnalysisType);
var SpiceMeasurementType;
(function (SpiceMeasurementType) {
    SpiceMeasurementType["Voltage"] = "v";
    SpiceMeasurementType["Current"] = "i";
    SpiceMeasurementType["VoltageImaginary"] = "vi";
    SpiceMeasurementType["VoltageReal"] = "vr";
    SpiceMeasurementType["VoltageMagnitude"] = "vm";
    SpiceMeasurementType["VoltagePhase"] = "vp";
    SpiceMeasurementType["VoltageDb"] = "vdb";
})(SpiceMeasurementType || (exports.SpiceMeasurementType = SpiceMeasurementType = {}));
exports.SpiceMeasurementTypeSchema = zod_1.default.nativeEnum(SpiceMeasurementType);
var SpiceModelType;
(function (SpiceModelType) {
    SpiceModelType["Resistor"] = "R";
    SpiceModelType["Capacitor"] = "C";
    SpiceModelType["Inductor"] = "L";
    SpiceModelType["SwitchVoltageControlled"] = "SW";
    SpiceModelType["SwitchCurrentControlled"] = "CSW";
    SpiceModelType["UniformlyDistributedRCLine"] = "URC";
    SpiceModelType["LossyTransmissionLine"] = "LTRA";
    SpiceModelType["Diode"] = "D";
    SpiceModelType["BJT_NPN"] = "NPN";
    SpiceModelType["BJT_PNP"] = "PNP";
    SpiceModelType["JFET_N"] = "NJF";
    SpiceModelType["JFET_P"] = "PJF";
    SpiceModelType["MOSFET_N"] = "NMOS";
    SpiceModelType["MOSFET_P"] = "PMOS";
    SpiceModelType["MESFET_N"] = "NMF";
    SpiceModelType["MESFET_P"] = "PMF";
    SpiceModelType["MOSFET_POWER"] = "VDMOS";
})(SpiceModelType || (exports.SpiceModelType = SpiceModelType = {}));
exports.SpiceModelTypeSchema = zod_1.default.nativeEnum(SpiceModelType);
//# sourceMappingURL=SpiceDefinitions.js.map